<template>
  <div class="r-add-new-address">
    <Modal :draggable="false" footer-hide v-model="show" fullscreen>
      <div class="title">
        {{
          type == 0
            ? $t("address.addTitle")
            : type == 1
              ? $t("address.addressDetails")
              : $t("address.Editaddress")
        }}
        <div
          class="iconfont iconguanbi common-hover"
          @click="show = false"
        ></div>
      </div>
      <!-- <div class="common-flex common-justify-center new-menu">
        <div
          class="common-hover"
          @click="changeTab(item)"
          v-for="(item, index) in $t('address.newMenu')"
          :style="[
            item.id == tabId ? { color: '#0A4DCC', fontWeight: 'bold' } : {},
          ]"
          :key="index"
        >
          {{ item.name }}
          <div v-if="item.id == tabId" class="common-line"></div>
        </div>
      </div> -->
      <div class="common-flex common-flex-wrap address-box">
        <div v-for="(item, index) in addressList" :key="index">
          <rIpt
            v-if="item.type == 'input'"
            :disabled="disabled"
            :config="item"
          ></rIpt>
          <rSelect
            :index="index"
            :disabled="disabled"
            @changeSelect="changeSelect"
            v-if="item.type == 'select'"
            :config="item"
          ></rSelect>
        </div>
      </div>
      <!-- <div v-show="tabId == 2" class="common-flex common-flex-wrap address-box">
        <div v-for="(item, index) in expressList" :key="index">
          <rIpt v-if="item.type == 'input'" :config="item"></rIpt>
          <rSelect v-if="item.type == 'select'" :config="item"></rSelect>
        </div>
      </div> -->
      <div class="common-flex common-justify-center options">
        <div
          class="default common-flex common-hover"
          v-if="addressId"
          @click="setDefault"
        >
          <div
            :style="[
              params.isDefault == 1 ? { backgroundColor: '#0A4DCC' } : {}
            ]"
            class="iconfont iconmoren"
          ></div>
          <div class="default-set">{{ $t("address.setDefault") }}</div>
        </div>
        <div class="back options-btn common-hover" @click="show = false">
          {{ $t("address.back") }}
        </div>
        <div
          class="save options-btn common-hover"
          v-if="type == 0 || type == 2"
          @click="save"
        >
          {{ $t("address.save") }}
        </div>
        <div class="save options-btn common-hover" v-else @click="edit">
          {{ $t("address.edit") }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import rIpt from "./r-ipt";
import rSelect from "./r-select";

export default {
  name: "r-add-new-address",
  components: {
    rIpt,
    rSelect
  },
  data() {
    return {
      // 新增地址
      params: {
        express: "", //快递公司
        expressType: "", //发货方式
        company: "", //公司
        contact: "", //联系人
        phone: "", //电话
        email: "", //邮箱
        countryCode: "", //国家code
        countryName: "", //国家名
        provinceCode: "", //省code
        provinceName: "", //省名字
        city: "", //国家
        address: "", //详细地址
        zipcode: "", //邮编
        payType: "", //支付方式
        payAccount: "", //付款账号
        payZipcode: "", //邮编
        taxType: "", //关税支付方式
        taxAccount: "", //关税支付账号
        taxZipcode: "", //关税支付邮编
        isOrigianl: "", //是否原产地证
        insuranceService: "", //是否保险服务
        dtpService: "", //是否dtp服务
        isDefault: "0",
        emailMessage: "0",
        remark: "",
        id: "", //编辑id
        // 地址信息JSON串
        addressInfo: ""
      },
      show: false,
      disabled: false,
      // tabId: 1,
      addressList: [],
      addressMsg: [
        {
          label: "ExpressName",
          must: true,
          type: "select",
          value: "",
          list: []
        },
        {
          label: "ExpressType",
          must: true,
          type: "select",
          value: "",
          list: []
        },
        {
          label: "Contacts/Company",
          must: true,
          type: "input",
          inputValue: ""
        },
        {
          label: "Phone",
          must: true,
          type: "input",
          inputValue: ""
        },
        {
          label: "Email",
          must: false,
          type: "input",
          inputValue: ""
        },
        {
          label: "Country",
          must: true,
          type: "select",
          value: "",
          list: []
        },
        {
          label: "State",
          must: true,
          type: "select",
          value: "",
          list: []
        },
        {
          label: "City",
          must: true,
          type: "input",
          inputValue: ""
        },
        {
          label: "Address1",
          must: true,
          type: "input",
          inputValue: ""
        },
        {
          label: "Zip",
          must: true,
          type: "input",
          inputValue: ""
        },
        {
          label: "Payment method",
          must: true,
          type: "select",
          value: "",
          list: []
        },
        {
          label: "Payment account",
          must: false,
          type: "input",
          inputValue: ""
        },
        {
          label: "Expresscode in located",
          must: false,
          type: "input",
          inputValue: ""
        },
        {
          label: "Tariff payment method",
          must: true,
          type: "select",
          value: "",
          list: []
        },
        {
          label: "Tariff payment account",
          must: false,
          type: "input",
          inputValue: ""
        },
        {
          label: "Expresscode in located",
          must: false,
          type: "input",
          inputValue: ""
        },
        {
          label: "Certificate of origin",
          must: false,
          type: "select",
          value: "0",
          list: [
            {
              id: 1,
              name: "YES"
            },
            {
              id: 0,
              name: "NO"
            }
          ]
        },
        {
          label: "Insurance Service",
          must: false,
          type: "select",
          value: "0",
          list: [
            {
              id: 1,
              name: "YES"
            },
            {
              id: 0,
              name: "NO"
            }
          ]
        },
        {
          label: "DTP Service",
          must: false,
          type: "select",
          value: "0",
          list: [
            {
              id: 1,
              name: "YES"
            },
            {
              id: 0,
              name: "NO"
            }
          ]
        },
        {
          label: "Remarks",
          must: false,
          type: "input",
          inputValue: ""
        }
      ]
    };
  },
  watch: {
    addNew: {
      handler(newVal, oldVal) {
        this.show = newVal;
        if (this.addressDetails && newVal) {
          let that = this;
          this.addressList = JSON.parse(JSON.stringify(this.addressMsg));
          this.addressList[0].value = Number(this.addressDetails.express);
          this.getDictSystem();
          this.changeSelect(0);
          this.addressList[1].value = this.addressDetails.expressType;
          this.addressList[2].inputValue = this.addressDetails.contact;
          this.addressList[3].inputValue = this.addressDetails.phone;
          this.addressList[4].inputValue = this.addressDetails.email;
          console.log(this.addressDetails);
          setTimeout(function () {
            that.addressList[5].list.map(item => {
              if (item.code == that.addressDetails.countryCode) {
                that.addressList[5].value = item.id; //省
                that.addressList[0].value = that.addressDetails.express;
                that.addressList[1].value = that.addressDetails.expressType;
                that.changeSelect(5);
              }
            });
          }, 800);
          setTimeout(function () {
            if (that.addressList[6].type == "input") {
              that.addressList[6].inputValue = that.addressDetails.provinceName;
            } else {
              that.addressList[6].list.map(item => {
                if (item.name == that.addressDetails.provinceName) {
                  that.addressList[6].value = item.id; //省
                  that.changeSelect(6);
                }
              });
            }
          }, 1200);
          setTimeout(function () {
            if (that.addressList[7].type == "input") {
              that.addressList[7].inputValue = that.addressDetails.city;
            } else {
              that.addressList[7].list.map(item => {
                if (item.name == that.addressDetails.city) {
                  that.addressList[7].value = item.id; //省
                }
              });
            }
          }, 1600);
          // if (this.addressList[6])
          // this.addressList[6].value = this.addressDetails  //市
          // this.addressList[7].value = this.addressDetails  //区
          this.addressList[8].inputValue = this.addressDetails.address;
          this.addressList[9].inputValue = this.addressDetails.zipcode;
          this.addressList[10].value = this.addressDetails.payType;
          this.addressList[11].inputValue = this.addressDetails.payAccount;
          this.addressList[12].inputValue = this.addressDetails.payZipcode;
          this.addressList[13].value = this.addressDetails.taxType;
          this.addressList[14].inputValue = this.addressDetails.taxAccount;
          this.addressList[15].inputValue = this.addressDetails.taxZipcode;
          this.addressList[16].value = this.addressDetails.isOrigianl;
          this.addressList[17].value = this.addressDetails.insuranceService;
          this.addressList[18].value = this.addressDetails.dtpService;
          this.addressList[19].inputValue = this.addressDetails.remark;
          // this.addressList.map((item,index)=>{
          //   this.addressList.splice(index,1,item)
          // })
        }
      },
      deep: true,
      immediate: true
    },
    show: {
      handler(newVal, oldVal) {
        if (!newVal) {
          // this.addressId = ''
          this.$emit("handlerAdd", newVal);
        }
      },
      deep: true,
      immediate: true
    },
    type: {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },
      immediate: true
    },
    addressId: {
      handler(newVal, oldval) {
        let that = this;
        if (!newVal) {
          this.params.id = "";
          this.params.isDefault = 0;
          this.addressList = JSON.parse(JSON.stringify(this.addressMsg));
          this.getDictSystem(); //快递信息
        } else {
          // 普通编辑
          // if (this.addressId) {
          this.params.id = this.addressId;
          this.selectOneAddressAction({id: this.addressId}).then(res => {
            this.params.isDefault = res.data.isDefault;
            // 如果存在id为编辑 //
            // 1.简易方法直接赋值
            // this.addressList = JSON.parse(res.data.addressInfo);
            // 2.复杂方式 获取单个数据依次赋值
            // 赋空值
            this.addressList = JSON.parse(JSON.stringify(this.addressMsg));
            this.addressList[0].value = Number(res.data.express);
            this.getDictSystem();
            this.changeSelect(0);

            this.addressList[1].value = res.data.expressType;
            this.addressList[2].inputValue = res.data.contact;
            this.addressList[3].inputValue = res.data.phone;
            this.addressList[4].inputValue = res.data.email;
            setTimeout(function () {
              that.addressList[5].list.map(item => {
                if (item.code == res.data.countryCode) {
                  that.addressList[5].value = item.id; //省
                  // that.addressList[5].value = item.id; //省
                  that.changeSelect(5);
                }
              });
            }, 500);
            setTimeout(function () {
              if (that.addressList[6].type == "input") {
                that.addressList[6].inputValue = res.data.provinceName;
              } else {
                that.addressList[6].list.map(item => {
                  if (item.name == res.data.provinceName) {
                    that.addressList[6].value = item.id; //省
                    that.changeSelect(6);
                  }
                });
              }
            }, 800);
            setTimeout(function () {
              if (that.addressList[7].type == "input") {
                that.addressList[7].inputValue = res.data.city;
              } else {
                that.addressList[7].list.map(item => {
                  if (item.name == res.data.city) {
                    that.addressList[7].value = item.id; //省
                  }
                });
              }
            }, 1200);
            console.log("res", this.addressList[6]);
            if (this.addressList[6])
              // this.addressList[6].value = res.data  //市
              // this.addressList[7].value = res.data  //区
              this.addressList[8].inputValue = res.data.address;
            this.addressList[9].inputValue = res.data.zipcode;
            this.addressList[10].value = res.data.payType;
            this.addressList[11].inputValue = res.data.payAccount;
            this.addressList[12].inputValue = res.data.payZipcode;
            this.addressList[13].value = res.data.taxType;
            this.addressList[14].inputValue = res.data.taxAccount;
            this.addressList[15].inputValue = res.data.taxZipcode;
            this.addressList[16].value = res.data.isOrigianl;
            this.addressList[17].value = res.data.insuranceService;
            this.addressList[18].value = res.data.dtpService;
            this.addressList[19].inputValue = res.data.remark;
          });
        }
      },
      deep: true,
      immediate: true
    },
    addressDetails: {
      handler(newval, oldval) {
        // this.$forceUpdate()
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    addNew: Boolean,
    // 类型 0普通新增  1查看  2编辑
    type: Number,
    addressId: [Number, String], //客户中心获取id请求数据
    addressDetails: [Object, String] //
  },
  mounted() {
    // this.getDictSystem(); //快递信息
  },
  methods: {
    ...mapActions([
      "getDictSystemAction", //系统字典
      "dictListAction", //省市区联动
      "saveAddressAction", //保存地址
      "selectOneAddressAction" //地址详情
    ]),
    // async changeSelects(e) {
    //     await this.changeSelect(e)
    // },
    // 列表变动 赋值数组
    changeSelect(e) {
      // 快递判断 省 市是填写还是输入
      let iptCity = {
        label: "City",
        must: true,
        type: "input",
        inputValue: ""
      };
      let iptState = {
        label: "State",
        must: true,
        type: "input",
        inputValue: ""
      };
      let selectCity = {
        label: "City",
        must: true,
        type: "select",
        value: "",
        list: []
      };
      let selectState = {
        label: "State",
        must: true,
        type: "select",
        value: "",
        list: []
      };
      if (this.addressList[e].value) {
        if (e == 0) {
          //修改快递地址获取联动列表
          // 发货方式
          this.dictListAction({
            expressId: this.addressList[0].value,
            category: 3
          }).then(res => {
            this.addressList[1].list = res.data;
          });
          // 国家
          this.dictListAction({
            expressId: this.addressList[0].value,
            category: 4
          }).then(res => {
            this.addressList[5].list = res.data;
          });
          // 付款方式
          this.dictListAction({
            expressId: this.addressList[0].value,
            category: 2
          }).then(res => {
            this.addressList[10].list = res.data;
          });
          // 关税付款方式
          this.dictListAction({
            expressId: this.addressList[0].value,
            category: 2
          }).then(res => {
            this.addressList[13].list = res.data;
          });

          // 选择顺丰  市为选择
          // if (this.addressList[0].value == 223147) {
          //   this.addressList.splice(7, 1, select);
          // } else {
          //   this.addressList.splice(7, 1, ipt);
          // }
          // 选择完快递方式置空之前的选项
          this.addressList[1].value = "";
          this.addressList[5].value = "";
          this.addressList[6].value = "";
          this.addressList[7].value = "";
          this.addressList[10].value = "";
          this.addressList[13].value = "";
        } else if (e == 5) {
          // 省  选择国家以后查 省跟市 是否可选的
          this.dictListAction({
            expressId: this.addressList[0].value,
            category: 5,
            parentId: this.addressList[5].value
          }).then(res => {
            if (res.data.length == 0) {
              this.addressList.splice(6, 1, iptState);
              this.addressList.splice(7, 1, iptCity);
              // this.addressList[6].inputValue = "";
            } else {
              this.addressList.splice(6, 1, selectState);
              this.addressList.splice(7, 1, selectCity);
              this.addressList[6].list = res.data;
              // this.addressList[6].value = "";
            }
          });
          // 置空省
        } else if (e == 6) {
          // 市赋值
          // if (this.addressList[0].value == 223147) {
          this.dictListAction({
            expressId: this.addressList[0].value,
            category: 6,
            parentId: this.addressList[6].value
          }).then(res => {
            if (res.data.length == 0) {
              this.addressList.splice(7, 1, iptCity);
            } else {
              this.addressList.splice(7, 1, selectState);
              this.addressList[7].list = res.data;
            }
          });
          // 置空市
          // }
        }
      }
    },
    // 获得快递信息
    getDictSystem() {
      this.getDictSystemAction({category: 92}).then(res => {
        res.data.map(item => {
          item.value = item.id;
          item.label = item.name;
        });
        this.addressList[0].list = res.data;
      });
    },
    // 设置默认
    setDefault() {
      if (this.type != 1) {
        this.params.isDefault == 1
          ? (this.params.isDefault = 0)
          : (this.params.isDefault = 1);
      }
    },
    // 点击编辑
    edit() {
      this.$emit("changeType");
      // this.type = 2
    },
    // 保存
    save() {
      let pass = true;
      for (var i = 0; i < this.addressList.length; i++) {
        if (
          this.addressList[i].must &&
          !this.addressList[i].inputValue &&
          !this.addressList[i].value
        ) {
          pass = false;
          this.$Message.error(
            this.$t("address.saveTips." + this.addressList[i].label)
          );
          break;
        }
      }
      if (pass) {
        this.params.express = this.addressList[0].value; //快递公司
        this.params.expressType = this.addressList[1].value; //发货方式
        this.params.contact = this.addressList[2].inputValue; //联系人
        this.params.company = this.addressList[2].inputValue; //公司
        this.params.phone = this.addressList[3].inputValue; //电话
        this.params.email = this.addressList[4].inputValue; //邮箱
        // 国家省市区 赋值 code 及 name
        // 国家赋值
        this.addressList[5].list.map(item => {
          if (item.id == this.addressList[5].value) {
            this.params.countryCode = item.code;
            this.params.countryName = item.name;
          }
        });
        // 省赋值
        if (this.addressList[6].type == "input") {
          this.params.provinceName = this.addressList[6].inputValue;
        } else {
          this.addressList[6].list.map(item => {
            if (item.id == this.addressList[6].value) {
              this.params.provinceCode = item.code;
              this.params.provinceName = item.name;
            }
          });
        }
        // 市赋值  区分是选择还是填写
        if (this.addressList[7].type == "input") {
          this.params.city = this.addressList[7].inputValue;
        } else {
          this.addressList[7].list.map(item => {
            if (item.id == this.addressList[7].value) {
              this.params.city = item.name;
            }
          });
        }
        this.params.address = this.addressList[8].inputValue;
        this.params.zipcode = this.addressList[9].inputValue;
        this.params.payType = this.addressList[10].value;
        this.params.payAccount = this.addressList[11].inputValue;
        this.params.payZipcode = this.addressList[12].inputValue;
        this.params.taxType = this.addressList[13].value;
        this.params.taxAccount = this.addressList[14].inputValue;
        this.params.taxZipcode = this.addressList[15].inputValue;
        this.params.isOrigianl = this.addressList[16].value;
        this.params.insuranceService = this.addressList[17].value;
        this.params.dtpService = this.addressList[18].value;
        this.params.remark = this.addressList[19].inputValue;
        this.params.addressInfo = JSON.stringify(this.addressList);
        if (this.addressDetails) {
          this.addressList[0].list.map(item => {
            if (item.id == this.addressList[0].value) {
              this.params.expressName = item.name; //快递公司
            }
          });
          this.addressList[1].list.map(item => {
            if (item.id == this.addressList[1].value) {
              this.params.expressTypeName = item.name; //快递公司
            }
          });
          this.$emit("saveConfirm", this.params);
        } else {
          this.saveAddressAction(this.params).then(res => {
            console.log("res", res);
            if (res.code == 0) {
              this.$emit("saveConfirm");
            }
          });
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .ivu-modal-body {
  padding: 0;
}

/deep/ .ivu-select-disabled .ivu-select-selection {
  color: #000;
}

/deep/ .ivu-icon-ios-close {
  display: none;
}

.address-box {
  width: 1130px;
  margin: 60px auto 0;

  > div {
    margin-bottom: 40px;
    margin-right: 40px;
  }

  > div:nth-child(3n + 3) {
    margin-right: 0;
  }
}

.options {
  // margin-top: 20px;
  position: relative;
  width: 1130px;
  margin: 20px auto;

  .default {
    position: absolute;
    left: 0;
    width: 140px;
    height: 30px;
    // border: 1px solid #999999;
    border-radius: 4px;

    .iconmoren {
      width: 32px;
      height: 32px;
      background: #999999;
      border-radius: 4px 0 0 4px;
      color: #fff;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
    }

    .default-set {
      width: 108px;
      text-align: center;
      line-height: 32px;
      height: 32px;
      color: #666666;
      border: 1px solid #999;
      border-radius: 0 4px 4px 0;
      border-left: none;
    }
  }

  .options-btn {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    background: #b5bac4;
    margin: 0 7px;
  }

  .save {
    background: #0a4dcc;
  }
}

.title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  font-family: Roboto;
  color: #081938;
  line-height: 24px;
  letter-spacing: 2px;
  // padding: 30px 0;
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;

  .iconguanbi {
    width: 80px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    font-size: 20px;
    position: absolute;
    top: 0;
    right: 0;
    color: #081938;
  }
}

.new-menu {
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  text-align: center;
  color: #525e73;
  line-height: 16px;
  padding-top: 20px;

  > div {
    margin: 0 100px;
    position: relative;
    padding-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-add-new-address.vue